export var MessageDisplay;
(function (MessageDisplay) {
    MessageDisplay[MessageDisplay["NONE"] = 0] = "NONE";
    MessageDisplay[MessageDisplay["AREA"] = 1] = "AREA";
    MessageDisplay[MessageDisplay["ON_DEMAND"] = 2] = "ON_DEMAND";
})(MessageDisplay || (MessageDisplay = {}));
